import ECSEditorContext from 'contexts/ECSEditorContext';
import Canvas from 'editor/components/Canvas';
import CarnivoreSheet from 'editor/components/CarnivoreSheet';
import React, { FC, PropsWithChildren, useContext, useEffect } from 'react';

type Props = PropsWithChildren<{
  sheetComp: CarnivoreSheet;
  canvasComp: Canvas;
  index: number;
}>;

// This component creates and manages the Carnivore "SheetLayer" component for a non-tiled sheet.
const ECSFullSheetLayer: FC<Props> = (props: Props) => {
  const { sheetComp, canvasComp, index } = props;
  const { carnCtx } = useContext(ECSEditorContext);

  useEffect(() => {
    const sheetLayer = carnCtx.ctx.createSheetLayer({
      id: `sheet-layer-${index}`,
      index,
    });

    sheetLayer.fillBuffer(canvasComp.canvas);
    sheetComp.sheet.addSheetLayer(sheetLayer.id);

    return () => {
      sheetLayer.destroy();
    };
  }, [canvasComp]); // a change to canvasComp will trigger for the initial and subsequent sheet layer changes

  const { children } = props;
  return <>{children}</>;
};

export default ECSFullSheetLayer;
